import { filledByType, ImmutableChat } from "@home-health-notify/domain";
import { useTranslation } from "hhn-commons";
import CommonDialog from "../../common/CommonDialog/CommonDialog";
import TemplateTabs from "../templates/TemplateTabs";
import { TemplateMessageContainer } from "./TemplateMessage.style";

interface TemplateMessageProps {
  isOpen: boolean;
  onClose: () => void;
  selectedRole?: filledByType;
  chat: ImmutableChat;
}

const TemplateMessage = ({
  isOpen,
  onClose,
  selectedRole,
  chat,
}: TemplateMessageProps) => {
  const { t } = useTranslation();
  const tNs = (key: string) => t(key, { ns: "message" });

  return (
    <CommonDialog
      isDialogOpen={isOpen}
      onDialogClose={onClose}
      title={tNs("templateMessage")}
      titleAlignment="center"
      isFullScreen={true}
    >
      <TemplateMessageContainer>
        <TemplateTabs
          onDialogClose={onClose}
          selectedRole={selectedRole}
          chat={chat}
        />
      </TemplateMessageContainer>
    </CommonDialog>
  );
};

export default TemplateMessage;
